export const API_VERSION_PREFIX = '/api/v1';
export const REDIS_KEY_PREFIX = 'leyrochain:';
export const SHARED_PACKAGE_VERSION = '0.0.1';
export * from './public-events.js';
export * from './catalogs/index.js';
export * from './breed-references.js';
//# sourceMappingURL=index.js.map